import { render, staticRenderFns } from "./GuideBalloon.vue?vue&type=template&id=53a2f057&scoped=true&"
import script from "./GuideBalloon.vue?vue&type=script&lang=ts&"
export * from "./GuideBalloon.vue?vue&type=script&lang=ts&"
import style0 from "./GuideBalloon.vue?vue&type=style&index=0&id=53a2f057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2f057",
  null
  
)

export default component.exports